import { Injectable } from '@angular/core';
import { UserDetail } from 'app/modules/chart/interface/interfaces';
import { Actions, AppStore } from '../index';
import { ReduxAction, ReduxType } from '../interface';

@Injectable()
export class UserActions extends Actions {
  constructor(appStore: AppStore) {
    super(appStore);
  }

  public storeUser(user: UserDetail): ReduxAction<UserDetail> {
    return { type: ReduxType.GET_USER, payload: user };
  }
}
